import React, { useCallback, useEffect, useState } from 'react';
import { Badge } from 'react-bootstrap';
import { durationSince } from '../../service/util';
import { CheckinSiteInfo } from './CheckinSiteInfo';
import { SummaryBlock } from '../common/SummaryBlock';
import { Spacer } from '../common/Spacer';
import tickWhite from '../../assets/svg/Tick-white.svg';
import { useCheckinState, useSiteState } from '../../state/state';

type ActiveCheckinSummaryProps = {
    durationSuffix?: string
}

export const ActiveCheckinSummary = ({durationSuffix}: ActiveCheckinSummaryProps) => {
    const { activeCheckin } = useCheckinState();
    const [duration, setDuration] = useState<string>();
    const { name } = useSiteState();

    const updateDuration = useCallback(() => {
        if (activeCheckin && activeCheckin.checkinTime) {
            const suffix = durationSuffix ? ' ' + durationSuffix : '';
            setDuration(durationSince(activeCheckin.checkinTime) + suffix);
        }
    }, [activeCheckin, durationSuffix]);

    useEffect(() => {
        updateDuration()
        const timeoutId = setInterval(() => {
            updateDuration();
        }, 5000);
        return () => clearInterval(timeoutId);
    }, [updateDuration]);

    return (
        <>
            <SummaryBlock display className="text-center">
                <Badge variant='success' pill className="py-2 pl-2 pr-3 text-white">
                    <div className="d-flex flex-row">
                        <img alt="" src={tickWhite} className="check-result"/>
                        <div className="my-auto pl-1 result-text">You&apos;re currently checked in at this site</div>
                    </div>
                </Badge>
            </SummaryBlock>
            <Spacer height="1em"/>
            <CheckinSiteInfo siteName={name} checkinTime={activeCheckin?.checkinTime} duration={duration}/>
        </>
    );
}
